import React from "react";

const CampaignsListView = React.lazy(() => import("./CampaignsList.view"));

const CampaignsListLoadable = () => <CampaignsListView />;
export default () => <CampaignsListLoadable />;
